import { Injectable, Injector } from '@angular/core';
import { EventSetupWizardStep } from '../../model/event-setup-wizard-step.enum';
import { AccessTokenSource, AuthService } from '@deltager/organizers/admin/core/services/auth.service';
import { Subject, firstValueFrom } from 'rxjs';
import {
  SaveChangesDialogComponent,
  SaveChangesDialogResult,
} from '@deltager/organizers/admin/shared/common-ui-components/save-changes-dialog/save-changes-dialog.component';
import { FotoWebDialogComponent } from '@deltager/organizers/admin/shared/common-ui-components/image-upload/fotoweb/fotoweb-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerOverlayService } from '@deltager/organizers/admin/shared/spinner-overlay/spinner-overlay.service';
import { SaveChangesSource } from '@deltager/organizers/admin/redux/root.state';

@Injectable({
  providedIn: 'root',
})
export class FotoWebService {
  dialogName = 'fotoWeb';

  constructor(
    private authService: AuthService,
    private injector: Injector,
    private dialog: MatDialog,
    private spinner: SpinnerOverlayService,
  ) {}

  private get translateService(): TranslateService {
    return this.injector.get(TranslateService);
  }

  async authenticate(returnUrl: string): Promise<void> {
    let url = returnUrl;

    var urlSplit = url.split('?');
    var urlWithoutParams = urlSplit[0];

    var params = new URLSearchParams();
    if (urlSplit.length === 2) {
      params = new URLSearchParams(urlSplit[1]);
    }

    params.set('tab', EventSetupWizardStep.EventDetails.toString());

    var failureRedirect = `${urlWithoutParams}?${params.toString()}`;

    params.set('dialog', this.dialogName);

    var successRedirect = `${urlWithoutParams}?${params.toString()}`;

    const l = await this.authService.getOAuthLink(AccessTokenSource.FotoWeb, successRedirect, failureRedirect);
    window.location.href = l;
  }

  async selectImage(
    returnUrl: string,
    server: string,
    saveChangesSubject: Subject<SaveChangesSource>,
  ): Promise<string> {
    const token = await this.authService.getAccessToken(AccessTokenSource.FotoWeb);

    if (token) {
      const ref = this.dialog.open(FotoWebDialogComponent, {
        height: '90vh',
        panelClass: ['no-padding-dialog', 'no-rounded-border-surface-dialog'],
        data: { accessToken: token, server },
      });

      const result = await firstValueFrom(ref.afterClosed());

      if (!result) {
        return;
      }

      return result.imageURL as string;
    }

    var saveChangesDialog = this.dialog.open(SaveChangesDialogComponent, {
      panelClass: 'responsive-dialog',
      data: { text: this.translateService.instant('eventsetup.event_details.save_changes_dialog.fotoweb_text') },
    });

    const r = await firstValueFrom(saveChangesDialog.afterClosed());

    if (r !== SaveChangesDialogResult.SaveAndContinue && r !== SaveChangesDialogResult.ContinueWithoutSaving) {
      return;
    }

    if (r === SaveChangesDialogResult.SaveAndContinue) {
      saveChangesSubject.next(SaveChangesSource.fotoWeb);
      return;
    }

    this.spinner.show();

    await this.authenticate(returnUrl).finally(() => this.spinner.hide());
  }
}
